<template>
     <section>
      <div class="max-w-screen-2xl mx-auto px-4 flex flex-wrap py-0 my-6">

          <div class="w-full md:w-6/12 pt-10 md:pr-20 overview">
              <h2 class="font-secondary text-2xl md:text-3xl mb-8">
                {{tr('Overview')}}
            </h2>
            <div class="flex text-dark font-normal text-md mb-2" v-for="(day, index) of dayList" :key="index">
              <span class="uppercase font-bold inline-block mr-2 w-2/12" v-if="noDateView">DAY {{day.dayNr}}</span>
                  <span class="uppercase font-bold inline-block mr-2 w-2/12" v-else>{{day.date}}</span>
                  <div class="w-10/12 flex flex-col" v-if="titles && titles[index]">
                    <span class="font-light" v-for="(title, ti) of titles[index]" :key="'ti-' + ti">
                      {{title}}.
                    </span>
                  </div>
            </div>
          </div>
          <div class="w-full md:w-6/12" v-if="services && bookingCities && bookingCities.length">
            <div class="overflow-hidden rounded-xl maps-container" id="mapDiv">
              <GoogleMap id="mainMap" ref="mainMap" :bookingCities="bookingCities"></GoogleMap>
              <GoogleMap :class="{'overlay-top': !hasPeru, 'overlay-bottom': hasPeru}"  v-if="hasPascua"
                :small="true" id="smallMap" :bookingCities="bookingCities"></GoogleMap>
            </div>
          </div>
      </div>
    </section>
</template>
<script>
import * as _ from 'lodash';
//var moment = require('moment');
import GoogleMap from '@/components/itinerary/GoogleMap.vue';
const api = window.api;
export default {
  name: 'TripOverview',
  props: {
  },
  data () {
    return {
      maps: false
    }
  },
  components: {
    GoogleMap
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.mainMap) this.maps = true;
    });
  },
  asyncComputed: {
    async titles () {
      let titles = {};
      if (this.dayList && this.dayList.length) {
        for (let j=0; j<this.dayList.length; j++) {
          titles[j] = {};
          let day = this.dayList[j];
          for (let i=0; i<day.services.length; i++) {
            if (!day.services[i]) continue;
            const replaceNote = this.$store.getters.replaceNote(day.services[i].code);
            if (!day.services[i].title && !replaceNote?.title) continue;
            let res = await api.extractText(replaceNote?.title || day.services[i].title);
            if (res) {
              titles[j][i] = res;
            }
          }
        }
      }
      return titles;
    },
    allServices () {
      return this.$store.state.allServices;
    },
    services () {
      return this.$store.getters.serviceStatusList();
    },
    bookingCities () {
      return this.$store.getters.bookingCities;
    },
    hasPascua () {
      if (!this.bookingCities) return false;
      return _.find(this.bookingCities, (r) => r.Longitude < -100);
    },
    hasPeru () {
      if (this.maps) {
        if (this.$refs.mainMap.hasPeru) return true;
      }
      return false;
    },     
    dayList () {
      return this.$store.getters.dayList;
      /*let res = [];
      if (this.services) {
        let days = _.map(this.services, (e) => {
          let d = moment(e.date, 'YYYY-MM-DD');
          return {
            date: d,
            dateString: d.format('YYYY-MM-DD'),
            title: e.Titulo || '',
            code: e.OPT_ID,
            description: e.Descripcion || '',
            location: e.LocationCode,
            locationName: e.LocationName,
            pcmPkgName: e.pcmPkgName,
            LineType: e.LineType,
          }
        });
        let unique = _.uniqBy(days, 'dateString');
        unique.sort((a, b) => {
          if (a.dateString > b.dateString) return 1;
          if (a.dateString < b.dateString) return -1;
          return 0
        });
        let firstDate = unique[0]? unique[0].date: null;
        res = _.map(unique, (r) => {
          let langCode = this.$root.langCode;
          if (langCode.toLowerCase() == 'sp') langCode = 'es';
          return {
              date: r.date.locale(langCode).format('DD MMM'),
              dateLong: `${r.date.locale(langCode).format('dddd DD MMM YYYY')}`.toUpperCase(),
              dateString: r.dateString,
              dayNr: r.date.diff(firstDate, 'day') + 1,
              services: _.map(_.filter(days, (d) => {
                  return d.dateString == r.dateString;
                }), (t) => {
                return {
                  title: t.title,
                  code: t.code,
                  description: t.description,
                  location: t.location,
                  locationName: t.locationName,
                  pcmPkgName: t.pcmPkgName,
                  LineType: t.LineType,
                }
              })
            }
        })
      }*/
      //return res;
    },
    noDateView () {
      return this.$store.state.noDateView;
    }
  },
  methods: {
    tr(key) {
      return this.$root.tr(key);
    },
  }
}
</script>

<style scoped>

.overview {
  padding-top: 0px;
}

.maps-container {
  position: relative;
  
}
.overlay-bottom {
  position: absolute;
  bottom: 0%; 
  left: 0; 
  width: 30%;
  height: 4rem;
}
.overlay-top {
  position: absolute;
  top: 0%; 
  left: 0; 
  width: 25%;
  height: 4rem;
}
</style>